import { ConfigProvider, Modal } from "antd";

const RedirectModal = ({ isModalOpen, setIsModalOpen, link }) => {

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOK = () => {
    window.open(link, '_blank')
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            contentBg: '#FFFFFF',
            headerBg: '#FFFFFF',
            titleFontSize: 24
          },
        },
        token: {
          colorText: 'black',
          fontSizeLG: 24,
          colorIcon: 'black',
          colorIconHover:'#CCCCCC'
        },
      }}
    >
      <Modal title='Redirection' open={isModalOpen} onCancel={handleCancel} onOk={handleOK} >
        <p>You are about to be redirected to this website:</p>
        <strong>{link}</strong>
      </Modal>
    </ConfigProvider>
  );
};

export default RedirectModal;